import {getDefaultStore} from 'jotai';
import {RESET} from 'jotai/utils';

import {calendarPeopleFilterAtom} from './calendarPeopleFilterAtom';
import {calendarViewAtom} from './CalendarViewToggle';
import {weekStartAtom} from './WeekStartToggle';

/** Reset calendar tile prefs (view, week start, people filters) to their defaults. */
export const resetCalendarTileSettings = () => {
  const store = getDefaultStore();
  store.set(calendarViewAtom, RESET);
  store.set(weekStartAtom, RESET);
  store.set(calendarPeopleFilterAtom, RESET);
};
